import React from 'react';

import requireAuth from '../../components/hocs/requireAuth';
import useIsMobile from '../../components/hooks/useIsMobile';
import { useAdDynamicConfig } from '../../components/hooks/useAdDynamicConfig';

import Inbox from './index';

const InboxWrapper = (props) => {
    const { showAds, inboxConfig } = useAdDynamicConfig();
    const { isMobileWidth, isTabletWidth } = useIsMobile();

    return (
        <Inbox
            showAds={showAds}
            inboxConfig={inboxConfig}
            isMobileWidth={isMobileWidth}
            isTabletWidth={isTabletWidth}
            {...props}
            data-testid="inbox"
        />
    );
};

export default requireAuth(InboxWrapper);
